<template>
	<el-dialog
		:visible.sync="isShow"
		width="6.4rem"
		id='monthType_dialog'
		:show-close='true'
		:lock-scroll='false'
	>	
		<div class='m_title'>
			选择要查看的月份<span class='yearColor'>（{{nowYear}}年）</span>
		</div>
		<div class='m_content'>
			<ul class='m_ul'>
				<li class='m_li' v-for='item in periodsInfoList' :key='item.period' :class='(item.haveData&&!item.checkOut)?"active_orange":(!item.haveData&&!item.checkOut)?"active_disabled":"active_bule"' :style='(!item.haveData&&!item.checkOut)?"":"cursor:pointer"' @click='handleCilck_month(item)'>
					<div class='m_m'>
						{{item.period}}月
					</div>
					<div class='m_info'>
						<span v-if='item.haveData'>统计中</span>
						<span v-if='item.checkOut'>已结转</span>
						<span v-if='!item.checkOut&&!item.haveData'>-</span>
					</div>
				</li>
			</ul>
		</div>
	</el-dialog>
</template>
<script>
	export default {
		props: {
			m_showVisible: Boolean,
			
		},
	
		data() {
			return {
				periodsInfoList: [], // 月份列表
				nowYear: null,   // 当前年
			}
		},
		created() {

		},
		computed: {
			// 显示弹窗
			isShow: {
				get () {
					return this.m_showVisible;
				},
				set (val) {
					this.$emit('update:m_showVisible', val);
				}
			},
		},
		methods: {
			
			// 月份点击效果
			handleCilck_month(item) {
				if(!item.haveData&&!item.checkOut) {
					return;
				}else if(item.checkOut){
					this.$emit('yearPeriod_m',item.yearPeriod);
					this.isShow = false;
				}else if(item.haveData) {
					this.$http.post('sys/login/index',{}).then(res=>{
						if(res.data.code == "1") {
							this.$message.warning("当前期间未结账还在统计中，数据仅供参考。");
						}
					})
					this.$emit('yearPeriod_m',item.yearPeriod);
					this.isShow = false;
				}
			},
			// 获取月份表/
			getPeriodsInfo() {
				let _=this;
				try {
					_.$http.post('Experience/periodsInfo',{}).then(res=>{
						if(res&&res.data.code==1) {
							_.periodsInfoList = res.data.data;
							_.nowYear = res.data.data[0].year;
						}
					})
				}catch(e) {

				}
			}
			
		},
		watch: {
			m_showVisible(val) {
				if(val) {
					this.getPeriodsInfo();
				}
			}
		}
	}
</script>
<style lang='less'>
	#monthType_dialog {
		.el-dialog__header {
			padding: 0;
		}
		.el-dialog__body {
			padding: .3rem;
		}
		.m_title {
			color: #000000;
			font-weight: bold;
			font-size: .16rem;
			.yearColor {
				color: #F5A623;
				margin-left: .1rem;
			}
		}
		.m_content {
			margin-top: .3rem;
			.m_ul {
				.m_li {
					width: .8rem;
					height: 1rem;
					display: inline-block;
					margin-left: .2rem;
					background: #268AFF;
					text-align: center;
					border-radius:2px;
					&:nth-child(1),{
						margin-left:0;
					};
					&:nth-child(7) {
						margin-left:0;
						margin-top: .2rem;
					}
					&:nth-child(8) {
						margin-top: .2rem;
					}
					&:nth-child(9) {
						margin-top: .2rem;
					}
					&:nth-child(10) {
						margin-top: .2rem;
					}
					&:nth-child(11) {
						margin-top: .2rem;
					}
					&:nth-child(12) {
						margin-top: .2rem;
					}
					.m_m {
						font-weight: bold;
						font-size: .18rem;
						color:#fff;
						margin-top: .2rem;
					}
					.m_info {
						font-size: .14rem;
						color:#fff;
						margin-top: .2rem;
					}
				}
				.active_bule {
					background: #268AFF;
				}
				.active_orange {
					background:#F5A623;
				}
				.active_disabled {
					background:#E0E0E0;
				}
			}
			
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/dialog/monthType.vue